import { useCallback, useState } from "react";
import { CancelRounded } from "@mui/icons-material";
import { Button, Stack, Typography } from "@mui/material";
import { DialogComponent } from "src/utils/GlobalModal/DialogComponent";
import { dynamicNotification } from "src/utils/Notifications";
import __ from "src/utils/Translations";

import { IWaitingRoom } from "src/Pages/Company/Pending/PendingBenefits/types";
import { useMassDecline } from "src/Pages/Company/Pending/PendingBenefits/query";
import { useSelectedRows } from "src/Pages/Company/Pending/PendingBenefits/SelectedRowsProvider/hooks";

export const DeclineWaitingRoom = ({
  waitingRoom,
}: {
  waitingRoom: IWaitingRoom;
}) => {
  const [open, setOpen] = useState(false);

  const { isPending, mutate } = useMassDecline();

  const { resetSelection } = useSelectedRows();

  const confirm = useCallback(() => {
    mutate(
      {
        documents: [],
        waitingRooms: [
          {
            waitingRoomId: waitingRoom.id,
            conditionIds: waitingRoom.conditions.map((item) => item.id),
          },
        ],
      },
      {
        onSuccess: () => {
          dynamicNotification(__("Pomyślnie odrzucono zamówienie"));
        },
        onError: () => {
          dynamicNotification(__("Nie udało się odrzucić zamówienia"), "error");
        },
        onSettled: () => {
          setOpen(false);
          resetSelection();
        },
      }
    );
  }, [mutate, resetSelection, waitingRoom.conditions, waitingRoom.id]);

  return (
    <>
      <Button
        color="error"
        size="small"
        variant="outlined"
        onClick={() => setOpen(true)}
      >
        {__("Odrzuć zamówienie")}
      </Button>
      <DialogComponent
        isOpen={open}
        onClose={() => setOpen(false)}
        title={__("Odrzuć zamówienie")}
        description={__("Te zmiany sa nieodwracalne")}
        actions={({ close }) => (
          <>
            <Button
              variant="outlined"
              color="inherit"
              disabled={isPending}
              onClick={close}
            >
              {__("Anuluj")}
            </Button>
            <Button
              variant="contained"
              color="error"
              loading={isPending}
              loadingPosition="start"
              onClick={confirm}
            >
              {__("Odrzuć")}
            </Button>
          </>
        )}
      >
        <Typography variant="body1">
          {__("Czy na pewno chcesz odrzucić to zamówienie?")}
        </Typography>
        <Stack sx={{ gap: 1, my: 2 }}>
          <Typography variant="subtitle1">
            {__("Produkt, który odrzucasz")}:
          </Typography>
          <Stack direction="row" sx={{ alignItems: "center", gap: 1 }}>
            <CancelRounded color="error" />
            <Typography color="error.dark" variant="body1">
              {waitingRoom.name}
            </Typography>
          </Stack>
        </Stack>
      </DialogComponent>
    </>
  );
};
